import { BrowserTabsVariantType } from '../../../../../../components/browserTab/types/browserTabs';
import { SingleTabVariantType, } from '../../../../../../components/browserTab/types/browserTabsTheme';
import { getShadow } from '../../../../../../designSystem/reloaded/config/shadow';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
import { commonSingleTab } from '../commonStyles';
export const getBrowserTabsRegular = (FOUNDATIONS) => ({
    [BrowserTabsVariantType.REGULAR]: {
        wrapper: {
            display: 'flex',
            width: '100%',
            height: 'auto',
            align_items: 'center',
            max_width: '100vw',
            position: 'relative',
            background_color: FOUNDATIONS.color_comp_navigation_browsertabs_bg,
        },
        container: {
            display: 'flex',
            align_items: 'flex-start',
            width: 'auto',
            height: 'fit-content',
            overflow_x: 'hidden',
            position: 'relative',
        },
        singleTab: {
            [SingleTabVariantType.UNSELECTED]: {
                ...commonSingleTab(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_navigation_browsertabs_bg,
                border_bottom_color: 'transparent',
            },
            [SingleTabVariantType.SELECTED]: {
                ...commonSingleTab(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_navigation_browsertabs_selected_bg,
                border_bottom_color: FOUNDATIONS.color_comp_navigation_browsertabs_selected_border,
            },
            [SingleTabVariantType.HOVER]: {
                ...commonSingleTab(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_navigation_browsertabs_hover_bg,
                border_right_color: 'transparent',
            },
        },
        browserTabControl: {
            display: 'flex',
            flex_wrap: 'nowrap',
            background_color: FOUNDATIONS.color_comp_navigation_browsertabs_bg,
        },
        addButtonWrapper: {
            white_space: 'nowrap',
        },
        titleContainer: {
            display: 'flex',
            align_items: 'center',
            overflow: 'hidden',
            flex: '1',
        },
        ellipsisContainer: {
            white_space: 'nowrap',
            text_overflow: 'ellipsis',
            overflow: 'hidden',
        },
        tabTextContainer: {
            white_space: 'nowrap',
            overflow: 'hidden',
            text_overflow: 'ellipsis',
            flex: '1',
            cursor: 'grab',
        },
        stackTabContainer: {
            flex_direction: 'column',
            padding: FOUNDATIONS.spacing_200,
            gap: FOUNDATIONS.spacing_150,
            border_radius: FOUNDATIONS.radius_200,
            box_shadow: `0 ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`,
            position: 'absolute',
            background_color: FOUNDATIONS.color_neutral_bg_static_100,
            top: '100%',
            width: 'fit-content',
            transform: 'translateX(-50%)',
        },
        stackTab: {
            background_color: FOUNDATIONS.color_neutral_bg_static_100,
            padding: FOUNDATIONS.spacing_250,
            display: 'flex',
            align_items: 'center',
            justify_content: 'space-between',
            border_bottom_width: FOUNDATIONS.spacing_25,
            border_bottom_style: 'solid',
            border_bottom_color: FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border,
            cursor: 'grab',
            width: FOUNDATIONS.size_1175,
        },
        stackTabsControl: {
            display: 'flex',
        },
        scrollLeftIcon: {
            enable: {
                color: FOUNDATIONS.color_accent_default_primary_icon_150,
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
            },
            disabled: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
            },
        },
        scrollRightIcon: {
            enable: {
                color: FOUNDATIONS.color_accent_default_primary_icon_150,
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
            },
            disabled: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
            },
        },
        moveUpIcon: {
            enable: {
                color: FOUNDATIONS.color_accent_default_primary_icon_150,
                height: FOUNDATIONS.size_300,
                width: FOUNDATIONS.size_300,
            },
            disabled: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                height: FOUNDATIONS.size_300,
                width: FOUNDATIONS.size_300,
            },
        },
        moveDownIcon: {
            enable: {
                color: FOUNDATIONS.color_accent_default_primary_icon_150,
                height: FOUNDATIONS.size_300,
                width: FOUNDATIONS.size_300,
            },
            disabled: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                height: FOUNDATIONS.size_300,
                width: FOUNDATIONS.size_300,
            },
        },
        dragIcon: {
            color: FOUNDATIONS.color_comp_forms_draggableitem_draggable_icon,
            height: FOUNDATIONS.size_300,
            width: FOUNDATIONS.size_300,
        },
        closeIcon: {
            color: FOUNDATIONS.color_comp_actions_closebutton_primary_default_icon,
            height: FOUNDATIONS.size_300,
            width: FOUNDATIONS.size_300,
        },
        reorderIcon: {
            color: FOUNDATIONS.color_accent_default_secondary_icon_100,
            height: FOUNDATIONS.size_300,
            width: FOUNDATIONS.size_300,
        },
        addIcon: {
            height: FOUNDATIONS.size_250,
            width: FOUNDATIONS.size_250,
        },
        singleTabText: {
            selected: {
                color: FOUNDATIONS.color_neutral_font_50,
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_bold,
            },
            unselected: {
                color: FOUNDATIONS.color_neutral_font_50,
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
            },
        },
        stackTabText: {
            color: FOUNDATIONS.color_neutral_font_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
        },
        reorderText: {
            color: FOUNDATIONS.color_neutral_font_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
        },
        tabContentPanel: {
            background_color: FOUNDATIONS.color_neutral_bg_375,
            overflow_y: 'auto',
        },
        boxShadow: getShadow(FOUNDATIONS).shadow_75,
    },
});
//# sourceMappingURL=getBrowserTabsRegular.js.map